// Utils de statut d'expédition
// Fournit des helpers centralisés pour labels et classes CSS.
// Evite la duplication entre pages Admin.

/**
 * Retourne le libellé français pour un statut d'expédition
 * @param {string} status
 * @returns {string}
 */
export function getStatusLabel(status) {
  const map = {
    delivered: 'Livré',
    pending: 'En attente',
    created: 'Expédition créée',
    in_progress: 'En cours',
    returned: 'Retourné',
    cancelled: 'Annulée',
    // Alias rétrocompatibilité
    in_transit: 'En cours',
  };
  return map[status] || 'Inconnu';
}

/**
 * Retourne les classes Tailwind pour badge de statut
 * @param {string} status
 * @returns {string}
 */
export function getStatusBadgeClass(status) {
  switch (status) {
    case 'delivered':
      return 'bg-green-100 text-green-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'created':
      return 'bg-blue-100 text-blue-800';
    case 'in_progress':
      return 'bg-indigo-100 text-indigo-800';
    case 'returned':
      return 'bg-red-100 text-red-800';
    case 'cancelled':
      return 'bg-red-100 text-red-800';
    // Alias rétrocompatibilité
    case 'in_transit':
      return 'bg-indigo-100 text-indigo-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

/**
 * Retourne les classes Tailwind pour le select de changement de statut
 * @param {string} status
 * @returns {string}
 */
export function getStatusSelectClass(status) {
  switch (status) {
    case 'delivered':
      return 'bg-green-100 text-green-800 border-green-300';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    case 'created':
      return 'bg-blue-100 text-blue-800 border-blue-300';
    case 'in_progress':
      return 'bg-indigo-100 text-indigo-800 border-indigo-300';
    case 'returned':
      return 'bg-red-100 text-red-800 border-red-300';
    case 'cancelled':
      return 'bg-red-100 text-red-800 border-red-300';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300';
  }
}
